module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fIXx9B/image/cover.jpg?1717958866489",
      "alt": "This image is the cover for the book Extra Cheesy Zits, Zits"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Extra Cheesy Zits, Zits\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A hilarious treasury of the beloved comic strip, featuring the daily struggles of an Ohio teen and his family.")]), _c('br'), _c('br'), _vm._v("Teenagers are unpredictable creatures. They don’t seem to follow a schedule, observe rules (of the road or basic logic), but occasionally, they make a surprising amount of sense. "), _c('i', [_vm._v("Extra Cheesy Zits")]), _vm._v(" is here to shed light on the always confounding, often amusing experience of parenting teens. Join the Duncan family—Connie, Walt, and Jeremy—as they grapple with modern technology, confront homework deadlines, and learn to bridge the cultural divide between parents and teenagers. "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _c('i', [_vm._v("Extra Cheesy Zits")]), _vm._v(" offers a light-hearted yet insightful look into the multifaceted lives of modern teens and their families, complemented by annotations from the creators. From mood swings to the perils of sharing a car, this collection broaches many familiar topics with humor and compassion.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jerry Scott, Jim Borgman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0